module.exports = __webpack_public_path__ + "img/closed_black_blurred.7cc4144c.png";